export default "__VITE_ASSET__Bjqx6Mqa__"